module.exports = __webpack_public_path__ + "static/media/imax_nebula1920.cb4432b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/imax_nebula1920.jpg
// module id = 1359
// module chunks = 0